.ux-sidebar-content {
  flex: 1 1 auto;
  overflow: auto;
  width: 100%;

  p {
    color: $color-gray-text;
  }
}
